<div class="wrapper">
  <div class="wrapper__close" (click)="close($event)" id="close-popin">
    <em class="rc-icon rc-icon--close"></em>
  </div>
  <app-loader [hidden]="(showPopinLoader$ | async) === false" [transparent]="false" [withinContent]="true"></app-loader>
  <ng-content></ng-content>
</div>
